module.exports = __webpack_public_path__ + "static/media/p33ru.8fd86aa6.pdf";